import { Component, type ReactNode } from 'react';
import { AsyncState } from './AsyncState';

interface Props {
  children: ReactNode;
  label?: string;
}

/** Contains render failures without exposing exception text or replaying a command. */
export class WorkspaceErrorBoundary extends Component<Props, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override render() {
    if (this.state.failed) {
      return (
        <section
          className="content-section"
          aria-label={`${this.props.label ?? 'Workspace'} recovery`}
        >
          <AsyncState
            state="error"
            message={`${this.props.label ?? 'This workspace'} could not be displayed. Try again to reload its data. If you were saving a change, check the record before submitting again.`}
            onRetry={() => this.setState({ failed: false })}
          />
        </section>
      );
    }
    return this.props.children;
  }
}
